import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { IoBedOutline } from "react-icons/io5";
import { PiBathtub } from "react-icons/pi";
import { MdSquareFoot } from "react-icons/md";
import { SiLevelsdotfyi } from "react-icons/si";
import MeetingRoomTwoToneIcon from "@mui/icons-material/MeetingRoomTwoTone";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PropertyPreview.css";

const PropertyPreview = () => {
  const navigate = useNavigate();
  const propertyGridRef = useRef(null);
  const [properties, setProperties] = useState([]);

  // Fetch all properties from API
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(
          "https://realo-realestate.com/api/api/Property/GetProperties"
        );
        setProperties(response.data); // Set the fetched properties
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    };
    fetchProperties();
  }, []);

  const handlePropertyClick = (property) => {
    navigate(`/properties/${property.title}/${property.propertyId}`);
  };
  const getPropertyTypeName = (propertyType) => {
    const typeMapping = {
      house: "Shtëpi",
      apartment: "Banesa",
      office: "Zyrë",
      store: "Lokal",
      land: "Toka",
      building: "Objekte",
    };

    // Return the mapped name or the original type if not found
    return typeMapping[propertyType.toLowerCase()] || propertyType;
  };

  const scrollLeft = () => {
    propertyGridRef.current.scrollBy({
      left: -propertyGridRef.current.clientWidth,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    propertyGridRef.current.scrollBy({
      left: propertyGridRef.current.clientWidth,
      behavior: "smooth",
    });
  };

  const handleViewMore = () => {
    navigate("/Property");
  };

  const renderIcons = (property) => {
    switch (property.propertyType.toLowerCase()) {
      case "house":
      case "apartment":
        return (
          <>
            <div className="property-preview-icon-detail">
              <IoBedOutline /> {property.bedrooms} Dhoma
            </div>
            <div className="property-preview-icon-detail">
              <PiBathtub /> {property.bathrooms} Banjo
            </div>
            <div className="property-preview-icon-detail">
              <SiLevelsdotfyi /> {property.floorLevel} Kati
            </div>
            <div className="property-preview-icon-detail">
              <MdSquareFoot /> {property.squareFeet}m²
            </div>
          </>
        );

      case "office":
      case "store":
        return (
          <>
            <div className="property-preview-icon-detail">
              <MeetingRoomTwoToneIcon /> {property.spaces} Hapësira
            </div>
            <div className="property-preview-icon-detail">
              <PiBathtub /> {property.bathrooms} Banjo
            </div>
            <div className="property-preview-icon-detail">
              <SiLevelsdotfyi /> {property.floorLevel} Kati
            </div>
            <div className="property-preview-icon-detail">
              <MdSquareFoot /> {property.squareFeet}m²
            </div>
          </>
        );

      case "land":
        return (
          <div className="property-preview-icon-detail">
            <MdSquareFoot /> {property.squareFeet}m²
          </div>
        );

      case "building":
        return (
          <>
            <div className="property-preview-icon-detail">
              <MeetingRoomTwoToneIcon /> {property.spaces} Hapësira
            </div>
            <div className="property-preview-icon-detail">
              <SiLevelsdotfyi /> {property.floorLevel} Kati
            </div>
            <div className="property-preview-icon-detail">
              <MdSquareFoot /> {property.squareFeet}m²
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <section className="property-preview-section">
      <div>
        <div className="property-preview-title d-flex justify-content-center align-items-center flex-row flex-md-row text-center text-md-start">
          <h1 className="display-4">REALO's</h1>
          <h3 className="display-4">New Properties</h3>
        </div>
        <hr />
      </div>

      <button className="property-preview-arrow left" onClick={scrollLeft}>
        <IoIosArrowBack />
      </button>
      <button className="property-preview-arrow right" onClick={scrollRight}>
        <IoIosArrowForward />
      </button>

      <div className="property-preview-grid d-flex" ref={propertyGridRef}>
        {properties.map((property) => (
          <div
            className="property-preview-card"
            key={property.propertyId}
            onClick={() => handlePropertyClick(property)}
          >
            <span className="property-preview-tag">
              {property.isForSale ? "SHITJE" : "QERA"}
            </span>
            <span className="property-preview-tag-type">
              {getPropertyTypeName(property.propertyType)}
            </span>
            <div className="property-preview-image-container">
              <img
                src={property.images?.[0]?.imageUrl}
                alt={property.title}
                className="property-preview-image"
              />
            </div>
            <div className="property-preview-details">
              <h3 className="property-preview-title">{property.city}</h3>
              <p className="property-preview-location">{property.title}</p>
              <p className="property-preview-price">
                €{property.price.toLocaleString()}
              </p>
              <div className="property-preview-icons mt-2">
                {renderIcons(property)}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="property-preview-view-more mt-4">
        <button onClick={handleViewMore} className="btn btn-dark">
          Shikoni Të Gjitha Pronat
        </button>
      </div>
    </section>
  );
};

export default PropertyPreview;
